/* eslint-disable default-param-last */
import { RedisTreatment } from '../../../lib/redis/types/RedisTreatment';
import SortAndFilterConfig from '../config/SortAndFilterConfig';

/**
 * Gets all the options to display for the active ingredient filter category.
 */
export const getActiveIngredientOptions = (treatments: RedisTreatment[] = [], config: SortAndFilterConfig) => {
    let activeIngredientList = treatments.reduce(
        (acc: string[], { activeIngredient }) => acc.concat(activeIngredient.map(({ title }) => title)),
        []
    );
    activeIngredientList = Array.from(new Set(activeIngredientList));

    const excludes = config?.filters?.activeIngredient?.excludes || [];

    return activeIngredientList.filter((ingredient) => !excludes.includes(ingredient) && !!ingredient).sort();
};

/**
 * Gets all the options to display for the brand filter category.
 */
export const getBrandOptions = (treatments: RedisTreatment[] = [], config: SortAndFilterConfig) => {
    let brandList = treatments.map(({ brand }) => brand);
    brandList = Array.from(new Set(brandList));

    const excludes = config?.filters?.brand?.excludes || [];

    return brandList.filter((brand) => !excludes.includes(brand) && !!brand).sort();
};

/**
 * Gets all the options to display for the condition filter category.
 */
export const getConditionOptions = (treatments: RedisTreatment[] = [], config: SortAndFilterConfig) => {
    let allConditions = treatments.reduce((acc: string[], { condition }) => acc.concat(condition.conditionsToFilter), []);
    allConditions = Array.from(new Set(allConditions));

    const excludes = [...(config?.filters?.conditions?.excludes || []), 'General Health'];

    return allConditions.filter((condition) => !excludes.includes(condition) && !!condition).sort();
};

/**
 * Gets all the options to display for the drug class filter category.
 */
export const getDrugClassOptions = (treatments: RedisTreatment[] = [], config: SortAndFilterConfig) => {
    let drugClassList = treatments.reduce((acc: string[], { drugClass }) => acc.concat(drugClass.map(({ title }) => title)), []);
    drugClassList = Array.from(new Set(drugClassList));

    const excludes = config?.filters?.drugClass?.excludes || [];

    return drugClassList.filter((classOfDrug) => !excludes.includes(classOfDrug) && !!classOfDrug).sort();
};

/**
 * Gets all the options to display for the treatment form filter category.
 */
export const getTreatmentFormOptions = (treatments: RedisTreatment[] = [], config: SortAndFilterConfig) => {
    let treatmentFormList = treatments.reduce(
        (acc: string[], { treatmentForm }) => acc.concat(treatmentForm.map(({ title }) => title)),
        []
    );
    treatmentFormList = Array.from(new Set(treatmentFormList));

    const excludes = config?.filters?.treatmentForm?.excludes || [];

    return treatmentFormList.filter((form) => !excludes.includes(form) && !!form).sort();
};
